/**
 * Created by sparakh on 6/8/16.
 */

;(function (EG, document, _) {
    
    // Contructor
    var ErrorRenderer = function (commonMessageContatinerId) {
        this.commonMessageContatinerId = commonMessageContatinerId;
    };
    
    ErrorRenderer.prototype = {
        constructor: ErrorRenderer,
        CLASS_NAMES: {
            ERROR_MESSAGE_CLASS: "input-message",
            FORM_ELEMENT_INVALID_CLASS: "invalid",
            FORM_ELEMENT_CONTAINER_CLASS: "input-container"
        },
        setElemValidity: function (valid, inputContainer, errClass) {
            var isParentValid = false;
            if(errClass){
                var errorNodes = this.getChildNodesByClassName(inputContainer,this.CLASS_NAMES.ERROR_MESSAGE_CLASS);
                if(errorNodes.length){
                    _.each(errorNodes, function (errorNode) {
                        if (errorNode.innerHTML.trim() !=="" && !(errorNode.classList.contains(errClass))) {
                            isParentValid = true;
                        }
                    });
                }
            }
            if (valid && !isParentValid) {
                inputContainer.classList.remove(this.CLASS_NAMES.FORM_ELEMENT_INVALID_CLASS);
            } else {
                inputContainer.classList.add(this.CLASS_NAMES.FORM_ELEMENT_INVALID_CLASS);
            }
        },
        getChildNodesByClassName: function (parentNode, className) {
            var childNodes = [];
            _.each(parentNode.childNodes, function (childNode) {
                if (childNode.classList && childNode.classList.contains(className)) {
                    childNodes.push(childNode);
                }
            });
            return childNodes;
        },
        createNewChildNode: function (parentNode, className, errClass) {
            var newEl = document.createElement('div');
            if(errClass) {
                newEl.classList.addMultiple(className, errClass);
            } else {
                newEl.classList.add(className);
            }
            return newEl;
        },
        displayErrorMessages: function (errors, inputContainer, multiple, errClass) {
            var errorCount = multiple ? (_.isArray(errors) ? errors.length : 1) : 1;
            var messageBlocks = this.prepareMessageBlocks(inputContainer, errorCount, errClass);
            for (var i = 0; i < errorCount; i++) {
                messageBlocks[i].innerHTML = _.isArray(errors) ? errors[i] : errors;
            }
        },
        removeErrorMessages: function (inputContainer, errClass) {
            var messageBlocks = this.getChildNodesByClassName(inputContainer, errClass ? errClass : this.CLASS_NAMES.ERROR_MESSAGE_CLASS);
            _.each(messageBlocks, function (messageBlock) {
                messageBlock.innerHTML = "";
            });
        },
        prepareMessageBlocks: function (inputContainer, count, errClass) {
            var messageBlocks = this.getChildNodesByClassName(inputContainer, errClass ? errClass : this.CLASS_NAMES.ERROR_MESSAGE_CLASS);
            if (messageBlocks.length < count) {
                var newBlocksCount = count - messageBlocks.length,
                    newChildNode;
                for (var i = 0; i < newBlocksCount; i++) {
                    newChildNode = this.createNewChildNode(inputContainer, this.CLASS_NAMES.ERROR_MESSAGE_CLASS, errClass)
                    inputContainer.appendChild(newChildNode);
                    messageBlocks.push(newChildNode);
                }
            }
            return messageBlocks;
        },
        fetchMessageBlocks: function (inputContainer) {
            return this.getChildNodesByClassName(inputContainer, this.CLASS_NAMES.ERROR_MESSAGE_CLASS);
        },
        fetchFormElementContainer: function (inputElement) {
            
            return this.fetchParentNodeByClass(inputElement, this.CLASS_NAMES.FORM_ELEMENT_CONTAINER_CLASS, 3) || inputElement.parentNode;
        },
        fetchParentNodeByClass: function (inputElement, className, level) {
            if (level != 0) {
                if (inputElement.parentNode.classList.contains(className)) {
                    return inputElement.parentNode;
                } else {
                    level--;
                    return this.fetchParentNodeByClass(inputElement.parentNode, className, level);
                }
            }
        },
        commonErrorMessageContainer: function()	{
            this._commonMessageContainer = this._commonMessageContainer || document.getElementById(this.commonMessageContatinerId);
            return this._commonMessageContainer;
        },
        displayCommonErrorMessages: function(type, messageList, scrollContainer)	{
            var errorDiv = this.commonErrorMessageContainer(),
                errTmpl = Handlebars.templates['partials/common/error'],
                msgContextList = [];
            _.each(messageList, function(msg)	{
                msgContextList.push({
                    type: type,
                    msg:msg
                });
            });
            errorDiv.innerHTML = errTmpl({messageList:msgContextList});
            errorDiv.style.display = 'block';
            //TODO: Refactor this function to remove this interstitial completion.
            uitk.publish('interstitial.complete', {contentId: EG.Users.Profile.Globals.InterstitialContainerId});

            EG.Users.Utils.scrollTop(errorDiv, scrollContainer);

        },
        displayDefaultError : function(){
            EG.Users.OmnitureUtil.omnitureTrackSomethingWentWrong();
            this.displayCommonErrorMessages(EG.Users.Constants.alertType.ERROR, [I18n.t('EGE_USERS_ERR_DEFAULT')]);
        },
        emptyCommonErrorMessageContainer: function()	{
            var errorDiv = this.commonErrorMessageContainer();
            if(errorDiv) {
                errorDiv.innerHTML = "";
                errorDiv.style.display = "none";
            }
        }
        
    };
    
    EG.Users.Utils.ErrorRenderer = ErrorRenderer;
})(EG, document, _);